import React from 'react';
import { Box } from 'grommet';
import './style.css';

export const MenuSeparator = ({}: any) => (
  <Box background="searchBar" width="2px" height="70%" />
);
